/**
 * Literal hex values for contexts where CSS variables (e.g. `hsl(var(--brand))`)
 * do NOT resolve — SVG presentation attributes such as recharts `fill`/`stroke`
 * and the custom SVG star-rating `fillColor`.
 *
 * Keep these in sync with the CSS variables in `src/styles/tailwind.css`.
 * For normal CSS contexts (className utilities, inline `style`, styled-components)
 * use the Tailwind tokens (`bg-brand`, `text-danger`, …) or `hsl(var(--token))`
 * instead of these constants.
 */
export const chartColors = {
	brand: "#49BD79", // Origo green
	action: "#219CD0", // action blue
	success: "#49BD79", // = brand green
	warning: "#FF6B00",
	danger: "#EB5757",
} as const;
